import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PageSeoQuery } from '@b2b-app/b2b-core';
import { UiBreadcrumb } from '../ui-breadcrumbs/ui-breadcrumb.model';
import { UiBreadcrumbsResolver } from '../ui-breadcrumbs/ui-breadcrumbs.resolver';

@Injectable({ providedIn: 'root' })
export class PageSeoBreadcrumbsResolver extends UiBreadcrumbsResolver {
  constructor(private pageSeoQuery: PageSeoQuery) {
    super();
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<UiBreadcrumb[]> | Promise<UiBreadcrumb[]> | UiBreadcrumb[] {
    const pageSlug = route.params.id;
    const crumbs = this.pageSeoQuery.allPages$.pipe(
      map((pageSeos) => {
        const page = pageSeos.find((page) => page.slug === pageSlug);
        const queryParams = state.url.split('?').pop();

        const crumb = {
          label: page?.titre,
          path: super.getFullPath(route.parent) + '/' + page?.slug,
        };

        let newCrumbs = [];

        if (queryParams) {
          const [query, pageId] = queryParams.split('=');

          if (query === 'parent') {
            const parentPage = pageSeos.find((page) => page.id === +pageId);
            const parentCrumb = {
              label: parentPage.titre,
              path: super.getFullPath(route.parent) + '/' + parentPage.slug,
            };
            newCrumbs = [...newCrumbs, parentCrumb];
          }
        }

        newCrumbs = [...newCrumbs, crumb];

        return newCrumbs;
      })
    );

    return crumbs;
  }
}
